<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1050" height="956" viewBox="0 0 1050 956" fill="none" style="margin: 0 auto">
    <rect width="1050" height="956" fill="white"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="600" letter-spacing="0.01em"><tspan x="486" y="924.628">В целом по региону
</tspan></text>
    <text text-anchor="end" fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="15" font-weight="600" letter-spacing="0.01em"><tspan x="802" y="925.1">{{getPcData.dkcpSt3 > 0 ? '+' : ''}}{{ $scripts.TableJs.formatNumberToRuFormat(getPcData.dkcpSt3) }}</tspan></text>
    <line x1="486" y1="906.5" x2="802" y2="906.5" stroke="#CFD8DC"></line>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="486" y="897.628">Потребность региона в КЦП по уровню
</tspan></text>
    <text text-anchor="end" fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="15" font-weight="500" letter-spacing="0.01em"><tspan x="802" y="898.1">{{ $scripts.TableJs.formatNumberToRuFormat(getPcData.opPst3) }}</tspan></text>
    <line x1="486" y1="879.5" x2="802" y2="879.5" stroke="#CFD8DC"></line>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="486" y="870.628">Объем КЦП для региона по уровню
</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="end" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="15" font-weight="500" letter-spacing="0.01em"><tspan x="802" y="871.1">{{
        $scripts.TableJs.formatNumberToRuFormat(getPcData.okcpSt3)
      }}</tspan></text>
    <path d="M809 849L809 847C809 842.582 805.418 839 801 839L759.391 839" stroke="#90A4AE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M483 849L483 847C483 842.582 486.582 839 491 839L532.609 839" stroke="#90A4AE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M646 828L646 831C646 835.418 649.582 839 654 839L761.754 839" stroke="#90A4AE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M646 828L646 831C646 835.418 642.418 839 638 839L530.246 839" stroke="#90A4AE" stroke-linecap="round" stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="586.035" y="809.28">     Заочная форма</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="832.035" y="809.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="547.907" y="768.22">Балансировка объема КЦП<title>Изменение потребности в КЦП в целях соответствия предельному объему КЦП для столичного региона по уровню образования, определенному исходя из плановой доли столичного региона в КЦП по данному уровню образования и форме обучения.</title>  для</tspan></text>

    <text xmlns="http://www.w3.org/2000/svg" fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
	<tspan x="723" y="763" data-tooltip="Изменение потребности в КЦП в целях соответствия предельному объему КЦП для столичного региона по уровню образования, определенному исходя из плановой доли столичного региона в КЦП по данному уровню образования и форме обучения.">?</tspan>
</text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="648" y="784.22">{{ getPcData.sprRegionNameGenitive }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="788.231" y="768.22">Прогнозируемый объем КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="894" y="784.22">{{ getPcData.sprRegionNameGenitive }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="648" y="736.18">{{
        (!Number.isNaN(getPcData.bst3) && (!(getPcData.bst3 >= 0))) ? '(' : ''
      }}{{ getPcData.bst3 }}{{
        (!Number.isNaN(getPcData.bst3) && (!(getPcData.bst3 >= 0))) ? ')' : ''
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em"><tspan x="894" y="736.18">{{ getPcData.kcp3 }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="512" y="731.765">+</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="758" y="731.765">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="336.035" y="809.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="322.158" y="768.22">Потребность в КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="398" y="784.22">{{
        getPcData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="398" y="736.18">{{
        getPcData.pbm3
      }}</tspan></text>
    <path d="M192 650L192 652C192 656.418 195.582 660 200 660L255 660" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M693 650L693 652C693 656.418 689.418 660 685 660L485 660" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M399 671L399 668C399 663.582 395.418 660 391 660L252 660" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M399 671L399 668C399 663.582 402.582 660 407 660L488 660" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="505.035" y="637.28">     Заочная форма</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="567" y="612.22">{{
        getPcData.sprRegionNameGenitive
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="456.1" y="596.22">Корректирующй коэффициент<title>Понижающий коэффициент, применяемый в случае, когда общий прогнозируемый объем КЦП по УГСН (НПС) по форме обучения ниже суммы потребности в КЦП столичных регионов по данной форме обучения.</title>   для</tspan></text>

    <text xmlns="http://www.w3.org/2000/svg" fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
	<tspan x="652" y="593" data-tooltip="Понижающий коэффициент, применяемый в случае, когда общий прогнозируемый объем КЦП по УГСН (НПС) по форме обучения ниже суммы потребности в КЦП столичных регионов по данной форме обучения.">?</tspan>
</text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="567" y="564.18">{{
        getPcData.kst3
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="431" y="559.765">×</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="255.035" y="637.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="205.455" y="596.22">Первичная потребность в КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="317" y="612.22">{{
        getPcData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="317" y="564.18">{{
        getPcData.ppbm3
      }}</tspan></text>
    <path d="M111 478L111 480C111 484.418 114.582 488 119 488L174 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M612 478L612 480C612 484.418 608.418 488 604 488L404 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M318 499L318 496C318 491.582 314.418 488 310 488L171 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M318 499L318 496C318 491.582 321.582 488 326 488L407 488" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="424.035" y="465.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="386.29" y="440.22">      для Российской Федерации</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="393.167" y="424.22">Прогнозируемый объем КЦП</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="486" y="392.18">{{
        getPcData.kcpRf3
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="350" y="387.765">×</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="174.035" y="465.28">     Заочная форма</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="236" y="424.22">Доля {{
        getPcData.sprRegionNameGenitive
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="138.664" y="440.22">в КЦП предшествующего года</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="236" y="392.18">{{
        getPcData.fkcpSt3
      }}</tspan></text>
    <path d="M29 305L29 307C29 311.418 32.5817 315 37 315L92 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M530 305L530 307C530 311.418 526.418 315 522 315L322 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M236 326L236 323C236 318.582 232.418 315 228 315L89 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M236 326L236 323C236 318.582 239.582 315 244 315L325 315" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="342.035" y="292.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="314.544" y="267.22">для Российской Федерации</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="309.045" y="251.22">КЦП на предшествующий год</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-size="47"
          font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan x="404" y="219.18">{{
        getPcData.kcpTrf3
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="268" y="214.765">:</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="92.0352" y="292.28">     Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="45.9314" y="251.22">КЦП на предществующий год для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="154" y="267.22">{{
        getPcData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="154" y="219.18">{{ getPcData.kcpT3 }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="29" y="151.04">Заочная форма</tspan></text>
    <line x1="30" y1="117.5" x2="1020" y2="117.5" stroke="#CFD8DC"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="96.24">Прогноз потребности в подготовке кадров осуществлен в разрезе регионов.</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="77.24">{{
        getPcData.sprKcpGroupSprUslName
      }}: {{ getPcData.sprKcpGroupId }} {{ getPcData.sprKcpGroupName }}.</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
          letter-spacing="0.01em"><tspan x="30" y="43.68">Прогнозирование общего объема КЦП для столичного региона</tspan></text>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "Pc3",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getPcData: {
        id: 0,
        sprKcpGroupId: "string",
        sprKcpGroupName: "string",
        sprKcpGroupSprUslName: "string",
        sprRegionId: "string",
        sprRegionName: "string",
        sprRegionNameGenitive: "string",
        pp: 0,
        d: 0,
        pbm: 0,
        pbm23: 0,
        kst1: 0,
        pbm1: 0,
        bst1: 0,
        kcp1: 0,
        kcpT2: 0,
        kcpTrf2: 0,
        kcpRf2: 0,
        kst2: 0,
        pbm2: 0,
        bst2: 0,
        opPst2: 0,
        kcp2: 0,
        kcpT3: 0,
        kcpTrf3: 0,
        kcpRf3: 0,
        kst3: 0,
        pbm3: 0,
        bst3: 0,
        opPst3: 0,
        kcp3: 0,
        ppbm1: 0,
        okcpSt1: 0,
        oppSt1: 0,
        dkcpSt1: 0,
        fkcpSt2: 0,
        ppbm2: 0,
        okcpSt2: 0,
        dkcpSt2: 0,
        fkcpSt3: 0,
        ppbm3: 0,
        okcpSt3: 0,
        dkcpSt3: 0
      }
    }
  },
  async created() {
    await this.getPcSvg();
  },
  methods: {
    async getPcSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getPc?kcpGroupId=${this.kcpGroupId}&regionId=${this.regionId}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getPcSvg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>